<rk-modal-wrapper
  (submitted)="onSubmit(data === null)"
  (cancelled)="closeSelf()"
  (closed)="closeSelf()"
  [title]="
    data?.break
      ? ('SCHEDULE.PLANNING.DELETE_MODAL_TITLE' | translate : { title: data.breakName })
      : ('SCHEDULE.PLANNING.DELETE_MODAL_SELECTED_TITLE'
        | translate : { count: (selectedBreaks$ | async) })
  "
  [submitText]="'SCHEDULE.PLANNING.DELETE_MODAL_SUBMIT' | translate"
  [loading]="isDeleting$ | async"
  [hideCancelOnLoading]="true"
>
  <div class="text-lg font-bold mb-1" translate>SCHEDULE.PLANNING.DELETE_MODAL_SURE</div>
  <div
    translate
    [innerHTML]="
      data?.break
        ? ('SCHEDULE.PLANNING.DELETE_BREAK_MODAL_MESSAGE' | translate)
        : ('SCHEDULE.PLANNING.DELETE_BREAKS_MODAL_MESSAGE'
          | translate : { count: (selectedBreaks$ | async) })
    "
  ></div>
  <mat-checkbox *ngIf="breakRepeat" class="mt-base" [(ngModel)]="deleteAll">{{
    'SCHEDULE.PLANNING.DELETE_MODAL_DELETE_ALL_OCCURRENCES' | translate
  }}</mat-checkbox>
</rk-modal-wrapper>
